import React from "react";
import { Phone, ArrowRight, ShieldCheck, Zap, Home } from "lucide-react";
import { COMPANY, IMAGES } from "../../lib/site-data";

const TrustBadge = ({ icon: Icon, label, testid }) => (
  <div
    data-testid={testid}
    className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/15 text-white text-sm font-medium"
  >
    <Icon className="h-4 w-4 text-[#FBBF24]" strokeWidth={2} />
    {label}
  </div>
);

export const Hero = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative isolate overflow-hidden bg-[#1D2B53] grain"
    >
      <div className="absolute inset-0">
        <img
          src={IMAGES.hero}
          alt="Taylor Made Plumbing & Services blueprint"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1D2B53]/85 via-[#1D2B53]/40 to-transparent"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-24 lg:pt-32 lg:pb-40">
        <div className="max-w-3xl">
          <div
            data-testid="hero-overline"
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#2563EB]/20 border border-[#2563EB]/40 text-[#A5C2FF] text-xs font-bold uppercase tracking-[0.18em] mb-6"
          >
            <span className="h-2 w-2 rounded-full bg-[#FBBF24]"></span>
            Conway, Arkansas — Owned by Jason Taylor
          </div>

          <h1
            data-testid="hero-headline"
            className="font-display text-4xl sm:text-5xl lg:text-7xl font-black text-white tracking-tight leading-[1.02]"
          >
            Plumbing Done <span className="text-[#FBBF24]">Right.</span>
            <span className="block mt-2 text-white/90">Taylor Made For You.</span>
          </h1>

          <p
            data-testid="hero-subheadline"
            className="mt-6 text-lg sm:text-xl text-white/80 max-w-2xl leading-relaxed"
          >
            Reliable plumbing and home services tailored to your needs. From repairs to full
            installations — we show up on time, do the job right, and treat your home like our own.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              href={COMPANY.phoneLink}
              data-testid="hero-call-now-button"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl bg-[#2563EB] hover:bg-[#1D4ED8] text-white font-semibold text-base shadow-xl shadow-blue-500/30 transition-all hover:-translate-y-0.5"
            >
              <Phone className="h-5 w-5" />
              Call Now: {COMPANY.phone}
            </a>
            <a
              href="#contact"
              data-testid="hero-estimate-button"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl bg-white hover:bg-gray-100 text-[#1D2B53] font-semibold text-base transition-all hover:-translate-y-0.5"
            >
              Get Free Estimate
              <ArrowRight className="h-5 w-5" />
            </a>
          </div>

          <div
            data-testid="hero-trust-badges"
            className="mt-10 flex flex-wrap gap-3"
          >
            <TrustBadge icon={Home} label="Locally Owned" testid="trust-badge-locally-owned" />
            <TrustBadge icon={Zap} label="Fast Response" testid="trust-badge-fast-response" />
            <TrustBadge icon={ShieldCheck} label="Reliable Service" testid="trust-badge-reliable" />
          </div>
        </div>
      </div>

      {/* Bottom marquee with slogan */}
      <div className="relative border-t border-white/10 bg-[#152043] py-3 overflow-hidden">
        <div className="flex animate-marquee whitespace-nowrap">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="flex shrink-0 items-center gap-12 px-8">
              {Array.from({ length: 8 }).map((_, j) => (
                <span
                  key={j}
                  className="font-display text-sm sm:text-base font-bold uppercase tracking-[0.3em] text-white/40 flex items-center gap-12"
                >
                  Taylor Made For You
                  <span className="h-1.5 w-1.5 rounded-full bg-[#FBBF24]"></span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
